import { httpPost, httpDownload } from '../../../utils/api.utils';
import {
    setManageUserHistoryLogsLoading
    , getManageUserHistoryLogs
    , setManageUserHistoryPageSize
    , resetManageUserHistory
    , setManageUserHistoryColSearchStr
} from '../../../constants/model-reducers/external/manage-user/manage-user-history.settings';

import { DEFAULT_TABLE_RESULT_MODEL } from '../../../constants/external-constants';
import { getLocalTimeZone, convertToFormatTimeZoneDate } from '../../../utils/helpers.utils';

const defaultState = () => ({
    HistoryTable: DEFAULT_TABLE_RESULT_MODEL,
    IsLoadingTable: false
});
 
const initialState = defaultState();

export const manageUserHistoryActions = {
    getManageUserHistoryLogs: (EmployeeId, pageIndex = 0) => async (dispatch, state) => {
        const { Pagination, Headers } = state().manageUserHistory.HistoryTable;
        var formData = {
            EmployeeID: EmployeeId,
            PageIndex: pageIndex,
            PageSize: Pagination.PerPage,
            PageSizes: Pagination.PageSizes,
            Headers: Headers
        };

        dispatch({
            type: setManageUserHistoryLogsLoading,
            isLoadingTable: true
        });

        var result = await httpPost('external/manageUser/getManageUserHistoryLogs', formData);

        //const formattedItems = result.Data.Items.map(item => {
        //    const formattedItem = { ...item };
        //    Object.keys(formattedItem).forEach(key => {
        //        if (key === 'OldValue' || key === 'NewValue') {
        //            const objectName = formattedItem['Object'];
        //            const value = formattedItem[key];
        //            if ((objectName === disputeHistoryObj.mrc || objectName === disputeHistoryObj.annualPotentialSavings || objectName === disputeHistoryObj.annualRealizedSavings
        //                || objectName === disputeHistoryObj.potentialsavings || objectName === disputeHistoryObj.realizedSavings) && !isNaN(value)) {
        //                const num = parseFloat(value);
        //                if (Number.isInteger(num) || String(value).endsWith('.0000')) {
        //                    formattedItem[key] = num.toFixed(2);
        //                }
        //            }
        //        }
        //    });
        //    return formattedItem;
        //});

        dispatch({
            type: getManageUserHistoryLogs,
            historyTable: result,
            isLoadingTable: false
        });
    },


    extractUserHistoryLogs: (EmployeeId) => async (dispatch, state) => {
        const { Pagination, Headers } = state().manageUserHistory.HistoryTable;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;
      
        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');
        const filename = `ATEM ${dealName} HR History – ${formattedTimeZoneDate}`;

        var formData = {
            EmployeeID: EmployeeId,
            Headers: Headers,
            FileName: filename,
            TimeZone: getLocalTimeZone()
        };
        httpDownload('external/manageUser/getExtractManageUser', formData)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },

    resizeManageUserHistoryLogs: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setManageUserHistoryPageSize,
            pageSize: parseInt(pageSize),
        });
    },

    setManageUserHistoryColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { HistoryTable } = state().manageUserHistory;
        var historyTableHeaderUpd = {
            ...HistoryTable,
            "Headers": {
                ...HistoryTable.Headers,
                [key]: {

                    ...HistoryTable.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setManageUserHistoryColSearchStr,
            historyTable: historyTableHeaderUpd
        });
    },
    resetmanageUserHistory: () => (dispatch, state) => {
        dispatch({
            type: resetManageUserHistory
        })
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setManageUserHistoryLogsLoading:
            return {
                ...state,
                IsLoadingTable: action.isLoadingTable
            }
        case getManageUserHistoryLogs:
            return {
                ...state,
                HistoryTable: action.historyTable,
                IsLoadingTable: action.isLoadingTable
            }
        case setManageUserHistoryPageSize:
            return {
                ...state,
                HistoryTable: {
                    ...state.HistoryTable,
                    Pagination: {
                        ...state.HistoryTable.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setManageUserHistoryColSearchStr:
            return {
                ...state,
                HistoryTable: action.historyTable,
            }
        case resetManageUserHistory:
            return initialState;
        default:
            return state;
    }
}